var React = require('react');

function Password (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.62834 9.37163C4.64166 7.35831 7.66622 6.9579 10.1294 8.15598L18.1133 0.172105L21.256 3.3148L19.7132 4.85758L22.8559 8.00028L19.7703 11.0858L16.6276 7.94314L13.2721 11.2987C14.4702 13.7618 14.0698 16.7864 12.0564 18.7997C9.50313 21.353 5.31463 21.3146 2.71405 18.714C0.113464 16.1134 0.075037 11.9249 2.62834 9.37163ZM5.80051 15.6287C6.66476 16.4929 8.06611 16.5058 8.91464 15.6573C9.76317 14.8087 9.75031 13.4074 8.88607 12.5431C8.02183 11.6789 6.62047 11.666 5.77194 12.5146C4.92342 13.3631 4.93627 14.7644 5.80051 15.6287Z","fill":"#262626"}));
}

Password.defaultProps = {"width":"23","height":"21","viewBox":"0 0 23 21","fill":"none"};

module.exports = Password;

Password.default = Password;
